"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isTablet = void 0;
const react_native_1 = require("react-native");
const isTablet = () => {
    if (react_native_1.Platform.OS === 'web') {
        return false;
    }
    return (react_native_1.Dimensions.get('window').height >= 800 &&
        react_native_1.Dimensions.get('window').width >= 500);
};
exports.isTablet = isTablet;
